import React from "react";

export const SignInLayout: React.FC<{
	children: React.ReactNode;
	title: string;
	subtitle: string;
}> = ({ children, title, subtitle }) => {
	return (
		<div
			style={{
				display: "flex",
				flexDirection: "column",
				alignItems: "center",
				justifyContent: "center",
				height: "100vh",
				backgroundColor: "var(--primary-main)",
			}}
		>
			<div
				style={{
					width: "400px",
					backgroundColor: "white",
					padding: "50px",
					overflowY: "auto",
				}}
			>
				<div
					style={{
						display: "flex",
						flexDirection: "column",
						gap: "10px",
						paddingBottom: "40px",
					}}
				>
					<div className="text-4xl font-bold">{title}</div>
					<div className="text-xl font-normal">{subtitle}</div>
				</div>
				{children}
			</div>
		</div>
	);
};
